// extracted by mini-css-extract-plugin
module.exports = {"bubbleMenu":"profile-bubble_bubbleMenu_vaC","links":"profile-bubble_links_gUR","subLinks":"profile-bubble_subLinks_1Xh","menuItem":"profile-bubble_menuItem_2r2"};